import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function MainGroups({ dataList, selected, setSelected, setSelectedSubGroup }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState("");
  const filteredList = dataList.filter(item =>
    item.areaName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div className={`
      ${selected ? 'hidden' : 'block'}
      md:block md:w-1/3 border-r overflow-y-auto transition-opacity duration-300 ease-in-out
    `}>
      {/* Search Bar */}
      <div className="p-4 border-b">
        <div className="relative">
          <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="Search areas..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Groups List */}
      {filteredList.map((item) => {
        const totalPax = item.memberSubscription.length;

        // Generate a consistent pseudo-random number based on area ID
        const seed = item.id.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const random = (seed * 9301 + 49297) % 233280; // simple LCG
        const activeUsers = totalPax === 0 ? 0 : Math.floor(Math.random() * totalPax) + 1;


        return (
          <div
      key={item.id}
      onClick={() => {
        setSelected(item);
        setSelectedSubGroup(null);
        setSearchParams({ id: item.id,tab:"Sub-Communities"  });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      className={`relative h-32 cursor-pointer overflow-hidden border-b group`}
    >
      {/* Background Image */}
      <img
        src={item.image}
        alt={item.areaName}
        className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-70 transition duration-300"
      />
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative z-10 flex flex-col justify-center h-full px-4">
        <div
          className={`${
            selected?.id === item.id ? "text-blue-100" : "text-white"
          } text-lg font-bold`}
        >
          {item.areaName}
        </div>
        <div
          className={`${
            selected?.id === item.id ? "text-blue-100" : "text-white"
          } text-sm opacity-80`}
        >
          {/* {totalPax} Pax */}
        </div>
        <div className="text-xs text-green-300">
          {activeUsers} active now
        </div>
      </div>
    </div>
        )
      }
      )}

      {filteredList.length === 0 && (
        <div className="p-4 text-gray-500">No areas found.</div>
      )}
    </div>
  );
}
